/**
 * AR content for the "Menton – Italian Riviera" private excursion.
 *
 * Role: Arabic (MSA) translation of slugs/riviera-italienne.ts, typed
 * `ExcursionPage` for the shared ExcursionSlugView.
 * Dependencies: slug-excursions (type), image. Slug mirrors FR
 * ("riviera-italienne") to keep the canonical join stable.
 */
import type { ExcursionPage } from "../slug-excursions";
import menton from "@/assets/images/excursions/destinations/menton.webp";

const page: ExcursionPage = {
  slug: "riviera-italienne",
  hero: {
    title: "رحلة مِنتون – الريفييرا الإيطالية",
    subtitle: "ألوان باستيل وحياة هانئة بين مِنتون والحدود الإيطالية.",
    ctaPrimaryHref: "/reservation",
    ctaPrimaryLabel: "احجز الآن",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "اطلب عرض سعر",
    image: menton,
  },
  highlights: {
    title: "أبرز المعالم",
    items: [
      { text: "مِنتون: واجهات بلون الباستيل وواجهة بحرية" },
      { text: "أجواء الحياة الهانئة على الجانب الإيطالي وأطباق محلية" },
      { text: "حدائق وفلل وإطلالات على البحر" },
      { text: "أسواق إيطالية (حسب اليوم)" },
    ],
  },
  itinerary: {
    title: "برنامج مقترح",
    steps: [
      {
        title: "مِنتون",
        description: "البلدة القديمة والكاتدرائية والواجهة البحرية.",
      },
      {
        title: "فينتيميليا (حسب اليوم)",
        description: "السوق والأطباق الإيطالية.",
      },
      {
        title: "بورديغيرا (اختياري)",
        description: "ممشى وفلل ومقاهٍ.",
      },
      {
        title: "ميلانو (اختياري ليوم كامل)",
        description:
          "تمديد عند الطلب مع مسار محسّن انطلاقًا من الريفييرا الإيطالية.",
      },
    ],
  },
  practical: {
    title: "معلومات عملية",
    items: [
      { label: "المدة", value: "من 4 إلى 7 ساعات" },
      { label: "الوثائق", value: "بطاقة هوية / جواز سفر" },
      { label: "الانطلاق", value: "كان" },
      { label: "التمديد", value: "ميلانو عند الطلب" },
      { label: "العملة", value: "اليورو (إيطاليا)" },
    ],
  },
};

export default page;
